module.exports = __webpack_public_path__ + "static/media/PM67.03cd386e.JPG";